import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "loren-trace-dialog",
    templateUrl: "./loren-trace-dialog.component.html",
    styleUrl: "./loren-trace-dialog.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenTraceDialogComponent {
  @Input() title: string;
  @Input() subtitle: string;

  @Output() continue = new EventEmitter<null>();
}
